// SPEC-464 M1.1 — 图标光学描边体系（Material 光学尺寸轴的 SVG 等价实现）。
// 零依赖纯 TS；worker/web 同源 import（layout.ts / canvasOps.ts 先例）→ doc SoT =
// 渲染 = critique 截图三方一致（spec M1.4）。
//
// 曲线：iconStrokePx(s) = clamp(2×√(s/24), 1.25, 3)，量化到 0.25。
// 语义 = 小图标相对加粗（光学补偿）、大图标相对收细 — E1 两端失衡根治
//（取证 doc-pmuup2b03f2jz：14px 状态栏恒 2px = 比 14.3% 粗重发糊；40px 金刚区
// = 5% 纤细失重；Lucide 24px 原生 8.3% = 设计原意锚点）。
// 关键点（M1 验收表）：14→1.5（10.7%）、16→1.75、24→2.0（8.3%，非回归锚点 =
// 现行为不变）、40→2.5（6.25%）、48→2.75。
//
// 墨迹含内（M1.2，单测 pin）：Lucide 24 格路径 inset ≈ 2u → 缩放后 inset = s×2/24；
// inset ≥ stroke/2 对 s ≥ 7.5 恒成立（角色档位 14/16/24/40 全覆盖：14px 时
// 1.1667 ≥ 0.75；40px 时 3.3333 ≥ 1.25；clamp 上限 3 仅 s ≥ 49.7 触达，彼时
// inset ≥ 4.1 ≥ 1.5）→ 墨迹恒在几何盒内，SPEC-462 M3 grounded 仲裁结论保全且更准
//（墨迹≈盒±stroke/2，取代旧「盒±1px」常数 — facts.ts/gateway.ts 同源接线）。

/** 光学描边宽（屏幕 px — 与 strokeScaleEnabled={false} 搭配，不随 scaleX/Y 缩放）。
 * clamp(2×√(s/24), 1.25, 3) 量化到 0.25；非法尺寸（非有限/≤0）防御回退旧常数 2
 *（SPEC-462 M3 行为），永不 throw。24 档 = 2.0 精确复现旧恒定描边（非回归锚点）。 */
export function iconStrokePx(size: number): number {
  if (!Number.isFinite(size) || size <= 0) return 2;
  const raw = 2 * Math.sqrt(size / 24);
  const clamped = raw < 1.25 ? 1.25 : raw > 3 ? 3 : raw;
  return Math.round(clamped * 4) / 4;
}
